export const DEMO_CONFIG = Object.freeze({
  demoMode: true,
  demoDebug: false,
  apiUrl: "",
  socketUrl: "",
  route: "/demo",
  currency: "USD",
  initialDemoBalance: 10_000,
  waitingDurationMs: 6_000,
  crashPauseMs: 1_800,
  multiplierTickMs: 50,
  minBet: 0.5,
  maxBet: 5_000,
});

export const isDemoMode = () => DEMO_CONFIG.demoMode;
